import classNames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';

import { useLocale } from '../../../Shared/locale';
import { Card } from '../../../Shared/UI/Card';
import { ColorBadge } from '../../../Shared/UI/ColorBadge';
import DateRange from '../../../Shared/UI/DateRange';
import { useRouter } from '../../router';
import { Charity, Product } from '../../types';

export default function ProductCard({
  product,
  charity,
}: {
  product: Product;
  charity: Charity;
}) {
  const { t } = useTranslation();
  const { formatCurrency, formatNumber } = useLocale();
  const { routes } = useRouter();

  const muted = !product.enabled && 'opacity-50';

  return (
    <Card
      spacing="xs"
      link={{
        href: routes.product_page(product.id),
      }}
    >
      <div className="grid grid-cols-[32px_5fr_2fr_3fr_4fr_1fr] gap-4 items-center">
        <div className={classNames(muted)}>
          {product.image_url ? (
            <div className="w-8 h-8">
              <img src={product.image_url} alt={product.title} className="block object-cover w-full h-full rounded" />
            </div>
          ) : (
            <ColorBadge name={product.title} color={charity?.brand_color || null} className="!rounded" />
          )}
        </div>
        <div className="min-w-0">
          <h4 className={classNames(muted, 'whitespace-nowrap overflow-hidden text-ellipsis')}>
            {product.title}
          </h4>
        </div>
        <div className={classNames(muted, 'text-sm')}>
          <span className="font-medium">
            {formatCurrency(product.selling_price)}
          </span>
        </div>
        <div className={classNames(muted, 'text-sm')}>
          <Trans
            i18nKey="backend:times_sold"
            values={{
              count: product.sold_count,
              value: formatNumber(product.sold_count),
            }}
          >
            <span className="font-medium" />
          </Trans>
        </div>
        <div className="text-sm text-slate-400">
          <DateRange start={product.start_at} end={product.end_at} />
        </div>
        <div className={classNames('text-right font-medium', product.enabled ? 'text-emerald-600' : 'text-slate-500')}>
          {product.enabled ? t('backend:live') : t('backend:offline')}
        </div>
      </div>
    </Card>
  );
}
